export default {
  title: 'Serviços',
  description: 'Organize os serviços disponíveis nos produtos e defina em quais áreas eles aparecem no catálogo e nos menus.',
  labels: {
    new: 'Novo Serviço',
  },
  fields: {
    name: 'Nome do Serviço',
    preserve_domain_level: 'Sempre exibir domínios',
  },
  groups: {
    data: 'Dados do serviço',
    domains: 'Domínios vinculados',
  },
  domains: {
    title: 'Domínios por serviços',
    description: 'Defina quais áreas funcionais pertencem a este serviço e se cada uma aparece no catálogo ou no menu.',
    labels: {
      new: 'Novo Vínculo',
    },
    fields: {
      name: 'Domínio',
      show_in_catalog: 'Exibir no catálogo',
      show_in_menu: 'Exibir no menu',
      menu_order: 'Ordem no menu',
      catalog_order: 'Ordem no catálogo',
    },
    errors: {
      duplicateCompositeKey: 'Já existe um vínculo para esta categoria e domínio.'
    }
  }
};
